import axios from '@axios'

export function ServiceCids() {
  this.cidsAll = query => new Promise((resolve, reject) => {
    axios.get('cids/all')
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        console.error('Erro ao buscar todos os registros:', err)
        reject(err)
      })
  })
}
